export default "__VITE_ASSET__86a574e1__"